export var hasCounter = function hasCounter(counter) {
  return typeof counter !== 'undefined';
};